__webpack_require__.p = "https://bundle.stayforlong.com/20251212.2/_next/";